import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-channel-partners',
  templateUrl: './channel-partners.component.html',
  styleUrls: ['./channel-partners.component.css']
})
export class ChannelPartnersComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
